module.exports = __webpack_public_path__ + "img/40_59.a3c83ef7.png";